export default __webpack_public_path__ + "static/media/brand3.b03c5d76.svg";